import $ from "jquery"
import {ReportGroupingLevel} from '../constants'
import InvoiceReportEditConfigController from './InvoiceReportEditConfigController'

export default class InvoiceEditFormConfigController extends InvoiceReportEditConfigController {}

InvoiceEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function(reportParameters) {
    let result = $.extend({}, reportParameters)

    if (!EnabledFeatures.UGR) {
        let groupings = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(
            ReportGroupingLevel.USER_GROUP,
            [result.firstGroupingLevel, result.secondGroupingLevel],
            ReportGroupingLevel.CUSTOMER,
        )
        result.firstGroupingLevel = groupings[0]
        result.secondGroupingLevel = groupings[1]
    }

    return result
}


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/InvoiceEditFormConfigController.js